import React, { useState, useEffect, useMemo, useRef } from "react";
import DataTable from "react-data-table-component";
import apiClient from "../api/apiClient";
import Select from "react-select";
import RuteoPendiente from "./RuteoPendiente";
import { Link, useNavigate } from "react-router-dom";

const PlanifLines = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [entDate, setEntDate] = useState("");
  const [project, setproject] = useState(null);
  const [projects, setProjects] = useState([]);
  const [choferes, setChoferes] = useState([]);
  const [camiones, setCamiones] = useState([]);
  const [chofer, setChofer] = useState([]);
  const [camion, setCamion] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [start_route, setStartRoute] = useState("");
  const [end_route, setEndRoute] = useState("");
  const [showRuteo, setShowRuteo] = useState(false);
  const navigate = useNavigate();
  const sapUser = JSON.parse(localStorage.getItem("sapUser"));
    const Company = sapUser?.CompanyDB || "";

  // ---- Cargar proyectos una sola vez
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await apiClient.get("/sales-orders/projects");
        const data = Array.isArray(res.data) ? res.data : [];
        setProjects(
          data.map((p) => ({ value: p.PrjCode, label: `${p.PrjName}` }))
        );

        const resChof = await apiClient.get("/logistica/choferes",{
            params: {
            company: Company,
            },
        });
        const dataChof = Array.isArray(resChof.data) ? resChof.data : [];
        setChoferes(
          dataChof.map((p) => ({ value: p.Code, label: `${p.U_NOMBRE}` }))
        );

        const resCam = await apiClient.get("/logistica/camiones",{
            params: {
            company: Company,
            }
        });
        const dataCam = Array.isArray(resCam.data) ? resCam.data : [];
        setCamiones(
          dataCam.map((p) => ({ value: p.Code, label: `${p.U_CHAPA} - ${p.U_MODELO}` }))
        );
      } catch (e) {
        console.error(e);
        setError("Error al obtener los datos iniciales.");
      }
    };
    fetchProjects();
  }, []);

  // ---- Obtener consolidado
  const fetchInsumos = async () => {
    setLoading(true);
    setError("");
    
    try {
      const { data } = await apiClient.get("/logistica/remisiones", {
        params: {
          project: project?.value ?? "",
          start_route,
          end_route,
          entDate,
          company: Company,
        },
      });

      const arr = Array.isArray(data) ? data : [];
    // cada elemento del array ya representa UNA entrega (DeliveryNote)
    setOrders(
      arr.map((any) => ({
        DocEntry: any.DocEntry,
        DocNum: any.DocNum,
        Project: any.Project,
        Gobernacion: any.CardName,
        Institucion: any.Name,
        FechaEntrega: any.DocDueDate || entDate || "",
        RutaIni: start_route,
        RutaFin: end_route,
        Orders: arr, // <- todas las líneas de TODAS las OV
      }))
    );
    } catch (e) {
      console.error(e);
      setError("Error al obtener entregas.");
    } finally {
      setLoading(false);
    }
  };

  const filteredOrders = useMemo(() => {
    if (!searchTerm) return orders;
    const q = searchTerm.toLowerCase();
    return orders.filter(
      (ov) =>
        (ov.Gobernacion || "").toLowerCase().includes(q) ||
        (ov.Project || "").toLowerCase().includes(q)
    );
  }, [orders, searchTerm]);

    const handleUpdateDeliveries = async () => {
        try 
        {
            if (!orders.length) {
            alert("No hay entregas para actualizar.");
            return;
            }
            if (!chofer?.value || !camion?.value) {
            alert("Selecciona chofer y camión.");
            return;
            }

            setSubmitting(true);
            setError("");

            // Tomamos las filas visibles (filtradas) para actualizar solo lo que ve el usuario
            const updates = (filteredOrders.length ? filteredOrders : orders).map((row) => ({
                DocEntry: row.DocEntry,
                U_CHOFERES: chofer.value,
                U_VEHICULO: camion.value,
                U_Enviar: "SI",
                U_dKmR: 10,
                U_iMotEmiNR: 8,
            }));

            // PATCH al backend (ruta nueva abajo)
            const resp = await apiClient.patch("/inventario/entregas", { orders: updates });

            const results = resp?.data || [];
            const ok = results.filter((r) => r.status === "success").length;
            const bad = results.filter((r) => r.status === "error").length;

            alert(
            `${ok ? `${ok} entregas actualizadas.\n` : ""}${
                bad ? `${bad} con errores.\n` : ""
            }${!ok && !bad ? "Sin cambios." : ""}`
            );

            await fetchInsumos();
        } catch (err) {
            console.error("Error actualizando entregas", err);
            setError("Ocurrió un error al actualizar las entregas.");
            alert("Ocurrió un error al actualizar las entregas.");
        } finally {
            setSubmitting(false);
        }
    };

  const columns = [
    { name: "ID Interno", selector: (row) => row.DocEntry, sortable: true, width: "130px" },
    { name: "Nro Documento", selector: (row) => row.DocNum, sortable: true, width: "130px" },
    { name: "Proyecto", selector: (row) => row.Project, sortable: true, width: "180px" },
    { name: "Gobernación", selector: (row) => row.Gobernacion, sortable: true, width: "360px" },
    { name: "Institucion", selector: (row) => row.Institucion, sortable: true, width: "360px" },
  ];

  return (
    <div className="container mt-4">
      <h2>Asignacion de Camiones en Remisiones Electrónicas</h2>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="row">
        <div className="col-md-5">
          <label>Código de Proyecto:</label>
          <Select options={projects} value={project} onChange={setproject} placeholder="Seleccione un proyecto..." isSearchable />
        </div>

        <div className="col-md-2">
          <label>Fecha de Entrega:</label>
          <input type="date" className="form-control" value={entDate} onChange={(e) => setEntDate(e.target.value)} />
        </div>

        <div className="col-md-1">
          <label>Ruta:</label>
          <input type="number" className="form-control" value={start_route} onChange={(e) => setStartRoute(e.target.value)} />
        </div>
      </div>

      <div className="row">
        <div className="col-md-5">
          <label>Choferes:</label>
          <Select options={choferes} value={chofer} onChange={setChofer} placeholder="Seleccione un chofer..." isSearchable />
        </div>

        <div className="col-md-5">
          <label>Camiones:</label>
          <Select options={camiones} value={camion} onChange={setCamion} placeholder="Seleccione un camion..." isSearchable />
        </div>

      </div>

      <div className="d-flex gap-2 mt-3 flex-wrap">
        <button className="btn btn-success" onClick={fetchInsumos} disabled={loading}>
          {loading ? "Cargando..." : "Obtener Datos"}
        </button>

        <button className="btn btn-primary" onClick={() => navigate('/logistica/ruteo-pendiente')} disabled={!project || !entDate}>
          Ruteo Pendiente
        </button>

        <button className="btn btn-dark" onClick={handleUpdateDeliveries} disabled={!orders.length || submitting}>
            {submitting ? "Actualizando Entregas..." : "Confirmar y Actualizar Entregas"}
        </button>
      </div>
      

      <DataTable
        className="mt-3"
        columns={columns}
        data={filteredOrders}
        pagination
        highlightOnHover
        dense
      />

      {showRuteo && (
        <RuteoPendiente
          visible={showRuteo}
          onClose={() => setShowRuteo(false)}
          project={project}
          entDate={entDate}
          startRoute={start_route}
          company={Company}
        />
      )}
    </div>
  );
};

export default PlanifLines;
